
import React from "react";
import { Event } from "@/types";
import EventCard from "./events/EventCard";
import EmptyEventsList from "./events/EmptyEventsList";

interface EventListProps {
  events: Event[];
}

const EventList = ({ events }: EventListProps) => {
  if (events.length === 0) {
    return <EmptyEventsList />;
  }

  return (
    <div className="space-y-6">
      {events.map(event => (
        <EventCard key={event.id} event={event} />
      ))}
    </div>
  );
};

export default EventList;
